export default "__VITE_ASSET__9dd95f40__"